import { CampaignViolation, CampaignViolationType } from 'consts/campaignViolations';

type CampaignViolationError = {
  response?: { data?: { violations?: ({ type?: string; message?: string } | null)[] } };
};

const CAMPAIGN_VIOLATION_TYPES = new Set<string>(Object.values(CampaignViolationType));

export const getCampaignViolations = (error: unknown): CampaignViolation[] => {
  const violations = (error as CampaignViolationError)?.response?.data?.violations;

  if (!Array.isArray(violations)) return [];

  const messageByType = new Map<CampaignViolationType, string>();

  violations.forEach((violation) => {
    if (!CAMPAIGN_VIOLATION_TYPES.has(violation?.type as string) || !violation?.message?.trim()) return;

    const type = violation.type as CampaignViolationType;

    if (!messageByType.has(type)) messageByType.set(type, violation.message as string);
  });

  return [...messageByType].map(([type, message]) => ({ type, message }));
};
